// istanbul ignore file
import { getTreatment } from '@eventbrite/splitio-client';
import { HOMEPAGE_WEBAPP_KEY, type SplitKey } from './constants';

// Evaluated per user (keyed by the logged-in public id) so Split targeting rules
// apply per user. The user key is required: without it the menu is disabled.
// This must NOT be evaluated in the cached SSR path (the homepage HTML is shared-
// cached, so a per-user value would leak); it is called from the uncached
// /home/api/zendesk-menu route and applied client-side.
export async function getShowZendeskMenuEnabled(userKey: SplitKey) {
    const treatment = await getTreatment(userKey, 'enable-zendesk-menu');
    return treatment === 'on';
}

export async function getLittleVeniceSpotlightEnabled() {
    const treatment = await getTreatment(HOMEPAGE_WEBAPP_KEY, 'enable_little_venice_spotlight');
    return treatment === 'on';
}

/**
 * Gates the US (.com) homepage SEO internal-linking changes: the expanded
 * "Top destinations" city list (GTF top 30) and the new "by state" module.
 * Keyed by the constant HOMEPAGE_WEBAPP_KEY (NOT per user), so it's a global
 * on/off that is safe to bake into the shared-cached SSR response and is seen by
 * logged-out / Googlebot requests.
 */
export async function getGeoSeoLinksEnabled() {
    const treatment = await getTreatment(HOMEPAGE_WEBAPP_KEY, 'enable_homepage_geo_seo_links');
    return treatment === 'on';
}

export async function getIsGuidesEnabled() {
    const raw = process.env.IS_GUIDES_ENABLED;
    if (!raw) return false;
    const normalized = String(raw).trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes';
}
